export default __webpack_public_path__ + "static/media/IMG_20220102_084820.4ba9e9bb.png";